module.exports = __webpack_public_path__ + "img/article66.08fc9cd6.jpg";